import { n8nApiSlice } from "../../../services/api";
import { PROMPT_TEMPLATE } from "../data";
import { IPromptTemplate } from "../types";

// HOTFIX: n8n 服務掛掉，暫時使用 hard-coded 資料
// TODO: 當 n8n 服務恢復後，請移除此段並恢復原本的 API 調用

// 以下是恢復 n8n 服務時需要的程式碼 (暫時註釋)
// const ENDPOINT_MAP = {
//     GET_PROMPT_TEMPLATE_URL: "/33b6125f-06fb-4f2f-b588-4fbcb06d374c",
// };

export const promptTemplateApiSlice = n8nApiSlice.injectEndpoints({
    endpoints: (builder) => ({
        // > 獲取角色提示詞模板
        getPromptTemplate: builder.query<IPromptTemplate[], void>({
            // HOTFIX: 暫時停用 n8n API 調用，使用 mock 資料
            queryFn: async () => {
                // 模擬 API 延遲
                await new Promise((resolve) => setTimeout(resolve, 100));
                return { data: PROMPT_TEMPLATE };
            },
            providesTags: ["n8n_PromptTemplate"],

            // 原本的 API 調用 (暫時註釋)
            // query: () => ({
            //     url: ENDPOINT_MAP.GET_PROMPT_TEMPLATE_URL,
            // }),
        }),
    }),
});

export const { useGetPromptTemplateQuery } = promptTemplateApiSlice;
